/* Selection-only enhancement: never owns prices, discounts, gifts or cart contents. */
(() => {
  'use strict';
  if (window.GuyaMoments) return;
  const themes = ['coffee', 'energy', 'flavours'];
  const trackingKey = key => /^(utm_|openai_)/i.test(key) || ['gclid','dclid','fbclid','msclkid','ttclid','twclid','li_fat_id','guya_moment','preview_theme_id'].includes(key);
  const navigationUrl = destination => {
    const current = new URL(window.location.href);
    const target = new URL(destination, current);
    if (target.origin !== current.origin) return destination;
    current.searchParams.forEach((value, key) => {
      if (trackingKey(key) && !target.searchParams.has(key)) target.searchParams.append(key, value);
    });
    return target.href;
  };
  window.GuyaMoments = { navigationUrl };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.getAttribute('href').startsWith('#')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin === window.location.origin && /\/(products|collections|pages|cart|checkout)(\/|$)/.test(url.pathname)) link.href = navigationUrl(link.href);
  }, true);

  class GuyaMomentFilter extends HTMLElement {
    connectedCallback() {
      if (this.initialized) { window.addEventListener('popstate', this.popstate); return; }
      this.initialized = true;
      this.host = this.closest('guya-bundle, guya-new-customer-builder');
      if (!this.host) return;
      this.cards = Array.from(this.host.querySelectorAll('[data-guya-motives]'));
      this.groups = Array.from(this.host.querySelectorAll('[data-product-group]'));
      this.originalOpen = new Map(this.groups.map(group => [group, group.open]));
      this.copy = JSON.parse(this.querySelector('[data-moment-copy]').textContent);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-moment-filter]');
        if (button) this.apply(button.dataset.momentFilter, true);
      });
      this.popstate = () => this.apply(new URL(window.location.href).searchParams.get('guya_moment'), false);
      window.addEventListener('popstate', this.popstate);
      this.hidden = false;
      this.popstate();
    }
    disconnectedCallback() { window.removeEventListener('popstate', this.popstate); }
    apply(requested, updateUrl) {
      const selected = themes.includes(requested) ? requested : 'all';
      if (this.active !== selected) {
        if (this.active === 'all') this.originalOpen = new Map(this.groups.map(group => [group, group.open]));
        this.cards.forEach(card => { card.hidden = selected !== 'all' && !card.dataset.guyaMotives.trim().split(/\s+/).includes(selected); });
        this.groups.forEach(group => {
          group.hidden = !Array.from(group.querySelectorAll('[data-guya-motives]')).some(card => !card.hidden);
          if (selected !== 'all') group.open = !group.hidden;
          else if (this.active) group.open = this.originalOpen.get(group);
        });
      }
      this.active = selected;
      this.querySelectorAll('[data-moment-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.momentFilter === selected)));
      const shown = this.cards.filter(card => !card.hidden).length;
      this.querySelector('[data-moment-status]').textContent = this.copy[selected] + ' ' + this.copy.count.replace('[[count]]', shown);
      this.querySelector('[data-moment-empty]').hidden = shown !== 0;
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (selected === 'all') url.searchParams.delete('guya_moment');
        else url.searchParams.set('guya_moment', selected);
        window.history.replaceState(window.history.state, '', url);
      }
    }
  }
  if (!customElements.get('guya-moment-filter')) customElements.define('guya-moment-filter', GuyaMomentFilter);

  class GuyaMomentChoices extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.links = Array.from(this.querySelectorAll('[data-moment-choice]'));
      this.panels = Array.from(this.querySelectorAll('[data-moment-panel]'));
      this.links.forEach(link => {
        link.setAttribute('aria-expanded', 'false');
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const value = link.dataset.momentChoice;
          this.links.forEach(other => other.setAttribute('aria-expanded', String(other === link)));
          this.panels.forEach(panel => { panel.hidden = panel.dataset.momentPanel !== value; });
          const panel = this.panels.find(item => item.dataset.momentPanel === value);
          panel.querySelector('h3').focus({ preventScroll: true });
          panel.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        });
      });
    }
  }
  if (!customElements.get('guya-moment-choices')) customElements.define('guya-moment-choices', GuyaMomentChoices);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-moment-buy]');
    if (!link) return;
    const form = document.getElementById(link.dataset.momentBuy);
    if (!form) return;
    const target = form.querySelector('[type="submit"]');
    if (!target) return;
    event.preventDefault();
    form.scrollIntoView({ behavior: 'auto', block: 'center' });
    target.focus({ preventScroll: true });
  });
})();
